import React, { memo } from 'react';
import './Stepper.css';

type StepperProps = {
  stepsCount: number;
  /**
   * Zero based index
   */
  step: number;
};

export const Stepper: React.FC<StepperProps> = memo(({ step, stepsCount }) => {
  return (
    <div className="stepper--container">
      {Array(stepsCount - (stepsCount - step))
        .fill(undefined)
        .map((_, i) => {
          return (
            <React.Fragment key={i}>
              <div
                role="contentinfo"
                aria-label={`Step ${i + 1} completed`}
                className="stepper--step stepper--step-completed"
              />
            </React.Fragment>
          );
        })}
      <div
        role="contentinfo"
        aria-label={`Step ${step + 1} active`}
        className="stepper--step stepper--step-active"
      />
      {Array(stepsCount - (step + 1))
        .fill(undefined)
        .map((_, i) => {
          return (
            <React.Fragment key={i}>
              <div
                role="contentinfo"
                aria-label={`Step ${step + 1 + (i + 1)} miss`}
                className="stepper--step"
              />
            </React.Fragment>
          );
        })}
    </div>
  );
});
